import {isValidElement as $hgUW1$isValidElement, Fragment as $hgUW1$Fragment, createElement as $hgUW1$createElement} from "react";
import $hgUW1$classnames from "classnames";

/* eslint-disable complexity, max-statements */ "use strict";
var $1a8b135a48ccd126$var$classIdSplit = /([\.#]?[a-zA-Z0-9_:-]+)/;
var $1a8b135a48ccd126$var$notClassId = /^\.|#/;
function $1a8b135a48ccd126$export$2e2bcd8739ae039(tag, props) {
    if (!tag) return "div";
    var noId = !("id" in props);
    var tagParts = tag.split($1a8b135a48ccd126$var$classIdSplit);
    var tagName = null;
    if ($1a8b135a48ccd126$var$notClassId.test(tagParts[1])) tagName = "div";
    var classes;
    var part;
    var type;
    var i;
    for(i = 0; i < tagParts.length; i++){
        part = tagParts[i];
        if (!part) continue;
        type = part.charAt(0);
        if (!tagName) tagName = part;
        else if (type === ".") {
            classes = classes || [];
            classes.push(part.substring(1, part.length));
        } else if (type === "#" && noId) props.id = part.substring(1, part.length);
    }
    if (classes) {
        if (props.className) classes.push(props.className);
        props.className = classes.join(" ");
    }
    return tagName ? tagName.toLowerCase() : "div";
}



"use strict";
function $57ef648a04ed7a17$var$h(componentOrTag, properties, children) {
    // if only one argument which is an array, wrap items with React.Fragment
    if (arguments.length === 1 && Array.isArray(componentOrTag)) return $57ef648a04ed7a17$var$h((0, $hgUW1$Fragment), null, componentOrTag);
    else if (!children && $57ef648a04ed7a17$var$isChildren(properties)) {
        // If a child array or text node are passed as the second argument, shift them
        children = properties;
        properties = {};
    } else if (arguments.length === 2) // If no children were passed, we don't want to pass "undefined"
    // and potentially overwrite the `children` prop
    children = [];
    properties = properties ? Object.assign({}, properties) : {};
    // Supported nested dataset attributes
    if (properties.dataset) {
        Object.keys(properties.dataset).forEach(function unnest(attrName) {
            var dashedAttr = attrName.replace(/([a-z])([A-Z])/, function dash(match) {
                return match[0] + "-" + match[1].toLowerCase();
            });
            properties["data-" + dashedAttr] = properties.dataset[attrName];
        });
        properties.dataset = undefined;
    }
    // Support nested attributes
    if (properties.attributes) {
        Object.keys(properties.attributes).forEach(function unnest(attrName) {
            properties[attrName] = properties.attributes[attrName];
        });
        properties.attributes = undefined;
    }
    // When a selector, parse the tag name and fill out the properties object
    if (typeof componentOrTag === "string") componentOrTag = (0, $1a8b135a48ccd126$export$2e2bcd8739ae039)(componentOrTag, properties);
    // Create the element
    const args = [
        componentOrTag,
        properties
    ].concat(children);
    return (0, $hgUW1$createElement).apply(null, args);
}
function $57ef648a04ed7a17$var$isChildren(x) {
    return typeof x === "string" || typeof x === "number" || Array.isArray(x);
}
var $57ef648a04ed7a17$export$2e2bcd8739ae039 = $57ef648a04ed7a17$var$h;




// An aggressive shorthand to create a react component
function $30b6ece83c3d853c$export$e7094788287c5e9b(c, props = {}) {
    /** A component that passes through children */ return (nextProps)=>{
        const { children: children } = nextProps;
        return (0, $57ef648a04ed7a17$export$2e2bcd8739ae039)(c, {
            ...props,
            children: children
        });
    };
}
const $30b6ece83c3d853c$export$f672e0b6f7222cd7 = (...args)=>function(props) {
        let c;
        const components = [
            ...args
        ];
        // Compose a series of react components
        let child = (0, $57ef648a04ed7a17$export$2e2bcd8739ae039)(components.pop(), props);
        while((c = components.pop()) != null)child = (0, $57ef648a04ed7a17$export$2e2bcd8739ae039)(c, null, child);
        return child;
    };




const $669f44fae38c5ae9$export$378a7f138e43d140 = function(props, ...addedClassNames) {
    let { className: className, ...rest } = props;
    className = (0, $hgUW1$classnames)(className, ...addedClassNames);
    return {
        className: className,
        ...rest
    };
};
const $669f44fae38c5ae9$export$2d100aab7348fb0a = (component, ...addedClassNames)=>function(props) {
        const newProps = $669f44fae38c5ae9$export$378a7f138e43d140(props, ...addedClassNames);
        return (0, $57ef648a04ed7a17$export$2e2bcd8739ae039)(component, newProps);
    };


function $149c1bd638913645$var$applyStyles(element, styles) {
    const { props: props } = element;
    const { className: className } = props;
    if (className == null) return element;
    let hasChanges = false;
    const newClasses = className.split(" ").map(function(d) {
        if (d in styles) {
            hasChanges = true;
            return styles[d];
        }
        return d;
    });
    if (!hasChanges) return element;
    // Create a new react element with local style substitutions
    return {
        ...element,
        props: {
            ...props,
            className: newClasses.join(" ")
        }
    };
}
function $149c1bd638913645$var$createNoOpHyper() {
    const _hyper = ()=>null;
    _hyper.if = ()=>_hyper;
    _hyper.styled = ()=>_hyper;
    _hyper.styles = ()=>{
        return {};
    };
    return _hyper;
}
const $149c1bd638913645$var$hyperCore = function(...args) {
    if (args.length === 2 && (0, $hgUW1$isValidElement)(args[1])) // Special case where a single child element is passed
    return (0, $57ef648a04ed7a17$export$2e2bcd8739ae039)(args[0], null, args[1]);
    return (0, $57ef648a04ed7a17$export$2e2bcd8739ae039).apply(this, args);
};
function $149c1bd638913645$var$createHyper(styles = {}) {
    const _hyper = function() {
        // First, run the core hyper function
        const el = $149c1bd638913645$var$hyperCore.apply(this, arguments);
        // If no styles are registered, return the element
        return $149c1bd638913645$var$applyStyles(el, styles);
    };
    _hyper.if = function(v) {
        // Only renders component if condition is met
        if (v) return _hyper;
        else // Return a no-op hyper
        return $149c1bd638913645$var$createNoOpHyper();
    };
    _hyper.styled = function(styles) {
        return $149c1bd638913645$var$createHyper(styles);
    };
    _hyper.styles = function() {
        return styles;
    };
    return _hyper;
}
const $149c1bd638913645$var$hyper = $149c1bd638913645$var$createHyper();
var $149c1bd638913645$export$2e2bcd8739ae039 = $149c1bd638913645$var$hyper;
const $149c1bd638913645$export$4fb1d09e9841b4e2 = $149c1bd638913645$var$hyper.if;
const $149c1bd638913645$export$41392b06df8961ec = $149c1bd638913645$var$hyper.styled;


export {$149c1bd638913645$export$2e2bcd8739ae039 as default, $149c1bd638913645$export$4fb1d09e9841b4e2 as hyperIf, $149c1bd638913645$export$41392b06df8961ec as hyperStyled, $30b6ece83c3d853c$export$f672e0b6f7222cd7 as compose, $30b6ece83c3d853c$export$e7094788287c5e9b as C, $669f44fae38c5ae9$export$2d100aab7348fb0a as classed, $669f44fae38c5ae9$export$378a7f138e43d140 as addClassNames};
//# sourceMappingURL=hyper.mjs.map
